import { jwtAuthAxios } from "../utils/network-utils";

export namespace LocationApi {
  export interface City {
    name: string;
    latitude: number;
    longitude: number;
  }

  export interface Country {
    name: {
      en: string;
    };
    iso3: string;
    iso2: string;
    latitude: number;
    longitude: number;
  }

  var cachedCountries: Country[] | undefined = undefined;

  export const listCountries = async (): Promise<Country[] | undefined> => {
    if (!cachedCountries) {
      const signedUrl = await jwtAuthAxios()
        .get<string>(`/json-data/countries`)
        .then((r) => r.data);

      cachedCountries = await fetch(signedUrl).then((r) => r.json());
    }
    return cachedCountries!;
  };

  export const listCities = async (
    countryIso2: string
  ): Promise<City[] | undefined> => {
    const signedUrl = await jwtAuthAxios()
      .get<string>(`/json-data/countries/${countryIso2}/cities`)
      .then((r) => r.data);

    return await fetch(signedUrl).then((r) => {
      return r.ok ? r.json() : undefined;
    });
  };
}
